export const categories = [
    { name: "U15 MASCULINO" },
    { name: "U17 MASCULINO" }
];